/**
 * Catch and alert about missing translations using nuxt-i18n-micro
 */
export default defineNuxtPlugin((nuxtApp: any) => {
  // TODO: enable again once current missing translations have been fixed
  return
  // eslint-disable-next-line no-unreachable
  const { $sentryCaptureMessage, $setMissingHandler } = nuxtApp
  $setMissingHandler((locale: string, key: string, routeName: string) => {
    $sentryCaptureMessage(`Missing translation: ${key} (${locale})`, {
      level: 'warning',
      tags: { locale, i18n: true },
      extra: { key, locale, routeName },
    })
  })
})
